import { render } from "./CollabHelp.vue?vue&type=template&id=82cecf8c&scoped=true"
import script from "./CollabHelp.vue?vue&type=script&lang=js"
export * from "./CollabHelp.vue?vue&type=script&lang=js"

import "./CollabHelp.vue?vue&type=style&index=0&id=82cecf8c&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82cecf8c"]])

export default __exports__